import t from"./function-bind-native.js";var a=t,n=Function.prototype.call,r=a?n.bind(n):function(){return n.apply(n,arguments)};export{r as default};
